<template>
  <div>
    <v-row class="mt-3">
      <v-col cols="2">
        <date-field v-model="form.from" label="From Date" />
      </v-col>
      <v-col cols="2">
        <date-field v-model="form.to" label="To Date" />
      </v-col>
      <v-col cols="3" class="pt-10 d-flex">
        <close-button width="100px" @click="resetFilter()">Reset</close-button>
        <primary-button width="100px" @click="fetchTransactions()"
          >Apply</primary-button
        >
      </v-col>
    </v-row>
    <static-table-view ref="table" :list="list" :headers="headers">
      <template v-slot:item.startWeek="{ item }"> {{ item.weekName }}</template>
      <template v-slot:item.created_date="{ item }">
        {{ item.created_at }}</template
      >
      <template v-slot:item.amount="{ value }">
        {{ formatPrice(value || 0) }}</template
      >
    </static-table-view>
  </div>
</template>

<script>
import {getHeaders, getStartEndDate} from "@/assets/utils/common.utils";
import PrimaryButton from "@/components/ui/buttons/PrimaryButton.vue";
import DateField from "@/components/ui/form/DateField.vue";
import {getDocs, limit, orderBy, query, where} from "firebase/firestore";
import {colTransactions, isLocal} from "@/assets/utils/firebase.utils";
import {fetchTransactionClients, mapDocs} from "@/assets/utils/doc.utils";
import CloseButton from "@/components/ui/buttons/CloseButton.vue";
import moment from "moment-timezone";
import StaticTableView from "../ui/StaticTableView.vue";
import ClientAutocomplete from "../clients/ClientAutocomplete.vue";

const defaultMonth = isLocal ? 12 : 3;

export default {
  props: {
    referral: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DateField,
    PrimaryButton,
    CloseButton,
    StaticTableView,
    ClientAutocomplete,
  },
  data() {
    return {
      dialog: false,
      isLoading: true,
      loading: false,
      list: [],
      detectedFrom: null,
      form: {
        from: moment().subtract(defaultMonth, "months").format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
        payout: "",
      },
    };
  },
  computed: {
    referralId() {
      return this.$route.params.id;
    },
    headers() {
      let doc = {
        created_at: "Date",
        client_name: "Client Name",
        reference_no: "Reference Number",
        amount: "Amount",
        client_type: "Client Type",
      };
      return getHeaders(doc);
    },
  },
  methods: {
    resetFilter() {
      this.form = {
        from: this.detectedFrom || moment().subtract(defaultMonth, "months").format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
        payout: "",
      };
      this.fetchTransactions(this.options);
    },
    query() {
      let queryList = [];
      let { start, end } = getStartEndDate(this.form);
      queryList.push(orderBy("created_at", "desc"));
      if (start && end) {
        queryList.push(where("created_at", ">=", start));
        queryList.push(where("created_at", "<=", end));
      }
      queryList.push(where("referral_id", "==", this.referralId));
      return query(colTransactions, ...queryList);
    },
    async fetchTransactions(options) {
      const vm = this;
      try {
        vm.loading = true;
        vm.options = options;
        let docs = (await getDocs(vm.query())).docs;
        vm.firstVisible = docs[0];
        vm.lastVisible = docs[docs.length - 1];
        let list = mapDocs(docs);
        vm.list = (await fetchTransactionClients(list)).map((i) => {
          return { ...i };
        });
        vm.loading = false;
      } catch (error) {
        console.log(error);
        vm.handleError(error);
      }
    },
  },
  async mounted() {
    await this.fetchTransactions();
    if (this.list.length < 50) {
      const q = query(
        colTransactions,
        where("referral_id", "==", this.referralId),
        orderBy("created_at", "desc"),
        limit(50)
      );
      const snap = await getDocs(q);
      if (!snap.empty && snap.docs.length > this.list.length) {
        const rawDate = snap.docs[snap.docs.length - 1].data().created_at;
        const date = rawDate && rawDate.toDate ? rawDate.toDate() : rawDate;
        this.detectedFrom = moment(date).format("YYYY-MM-DD");
        this.form.from = this.detectedFrom;
        this.form.to = moment().format("YYYY-MM-DD");
        await this.fetchTransactions();
      }
    }
  },
};
</script>

<style></style>
